import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { Plan } from '../classes/plan';
import * as moment from 'moment';

import { HelperService } from '../services/helper.service';
import { Activity } from '../classes/activity';

@Injectable({
  providedIn: 'root'
})
export class PlanStore {

  constructor(
    private storage: Storage,
    private helper: HelperService
  ) {

  }

  plans = new BehaviorSubject([] as Plan[]);
  fs = firebase.firestore();
  currentPlan = new BehaviorSubject(new Plan())
  currentActivity = new BehaviorSubject(new Activity())

  
  async initPlans() {
    return new Promise(async (resolve) => {
      let plans = await this.storage.get('plans');
      if (!plans || plans.length == 0) {
        let uid = localStorage.getItem('uid');
        this.fs.collection('plans').where('uid', '==', uid).get().then(s => {
          plans = s.docs.map(d => d.data()) || [];
          this.updatePlans(plans);
          return resolve(true)
        })
      } else {
        this.updatePlans(plans);
        return resolve(true)
      }
    })
  }


  updatePlans(plans: Plan[]) {
    plans = plans || []
    this.plans.next(plans);
    this.storage.set('plans', plans);

  }

  addPlan(plan: Plan) {
    return new Promise(async (resolve) => {
      this.helper.showLoading();
      let plans = this.plans.getValue();
      let newPlan = await this.saveToFirestore(plan);
      plans.push(newPlan);
      this.updatePlans(plans);
      this.helper.hideLoading();
      return resolve(newPlan)
    })
  }

  deletePlan(plan: Plan) {
    this.currentPlan.next({} as any)
    return new Promise((resolve) => {
      this.deleteFromFirestore(plan).then(() => {
        let plans = this.plans.getValue();
        plans = plans.filter(p => p.id != plan.id);
        this.updatePlans(plans);
        return resolve(true)
      })
    })
  }

  updatePlan(plan) {
    return new Promise((resolve) => {
      this.updateFirestore(plan).then((newPlan) => {
        console.log('made it here....', newPlan.endTimeString, plan.endTimeString)
        let plans = this.plans.getValue();
        if (plans) {
          let index = plans.findIndex(p => p.id == plan.id);
          plans.splice(index, 1, newPlan);
          this.updatePlans(plans);
        }
        return resolve(true)
      })
    })
  }

  getPlansFromFirestore(): Promise<Plan[]> {
    return new Promise((resolve) => {
      let uid = localStorage.getItem('uid');
      this.fs.collection('plans').where('uid', '==', uid).get()
        .then((snap) => {
          let plans = (snap.docs.map(d => d.data())) as Plan[];
          return resolve(plans)
        })
    })

  }


  updateFirestore(plan: Plan): Promise<Plan> {
    plan = { ...plan };
    plan.modified = new Date().getTime();
    plan.modifiedString = moment(plan.created, 'x').format('LLLL')
    return new Promise((resolve) => {
      this.fs.doc(plan.path).set({ ...plan }).then(async () => {
        let newPlan = (await this.getFromFirestore(plan.path) as Plan);
        return resolve(newPlan)
      })
    })
  }

  saveToFirestore(plan: Plan): Promise<Plan> {
    plan = { ...plan };
    plan.created = new Date().getTime();
    plan.createdString = moment(plan.created, 'x').format('LLLL')
    plan.modified = new Date().getTime();
    plan.modifiedString = moment(plan.created, 'x').format('LLLL')
    return new Promise(async (resolve) => {
      this.fs.collection('plans').add(plan).then(async (result) => {
        await result.update({ id: result.id, path: result.path })
        let newPlan = await this.getFromFirestore(result.path) as unknown as Plan;
        return resolve(newPlan)
      })
    })
  }

  getFromFirestore(path: string): Promise<Plan> {
    return new Promise((resolve) => {
      this.fs.doc(path).get().then(result => {
        let data = (result.data() ? result.data() : null) as Plan
        return resolve(data);
      })
    })
  }

  deleteFromFirestore(plan: Plan) {
    return new Promise((resolve) => {
      this.fs.doc(plan.path).delete().then(() => {
        resolve(true)
      })
    })
  }
}
